import en from '../locale/en';

let _i18n = {};

export const locale = key => {
  if (!key) {
    return '';
  }
  const msg = key.split(/\.(.+)/);
  const a = _i18n[msg[0]];
  return (a && a[msg[1]]) || !1;
};

const load = data => {
  _i18n = data;
};

load(en);



// WEBPACK FOOTER //
// ./utils/i18n.js